export const NAV_ITEMS = [
  { label: 'NAVS.HOME', fragment: 'home' },
  { label: 'NAVS.SOLUTIONS', fragment: 'solutions' },
  { label: 'NAVS.WHY_CHOOSING_ECHOZA', fragment: 'why-us' },
  { label: 'NAVS.CONTACT_US', fragment: 'contact' },
  { label: 'NAVS.FAQ', fragment: 'faq' },
];
